/**
 * Configuration for PAGE Cooperative Career Center frontend.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'us';
const locales = ['en'];
const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'PAGE Cooperative Career Center',
    SITE_DESCRIPTION:
      'Your source for media jobs. The PAGE Cooperative Career Center connects newspaper, publishing and media professionals with employers across the industry.',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    ASSETS: {
      logo: '/static/pagecooperative/logo.png',
      faviconsPath: '/static/pagecooperative',
    },
    OG_IMAGE: '/static/pagecooperative/og-image.png',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#2a3a8f',
        secondary: '#2b94d0',
      },
      logo: {
        minHeight: 60,
      },
    },
    PRICE_CONFIG: priceConfig,
    BLOG_FEATURE_ACTIVE: false,
    GA4_MEASUREMENT_IDS: ['G-04SBN34ERZ'],
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: true,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
  },
});
